module.exports = __webpack_public_path__ + "static/media/tutorial-macros-step2.5d9a883a.png";